import { LitElement, html } from "lit";
class BCPackageSupplierDetails extends LitElement {
  data = null;
  packageTemplate = null;

  render() {
    return html`
      <h3>Leveranciersdata</h3>
      <p class="explanation"></p>
    `;
  }
}

const initBCPackageSupplierDetails = () => {
  window.customElements.define(
    "bc-package-supplierdetails",
    BCPackageSupplierDetails
  );
};
export { initBCPackageSupplierDetails };
